module.exports = __webpack_public_path__ + "img/icon-forgot-2.920d38e3.svg";